import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import styles from "./style.module.scss";
import settingsActions from "../../../../redux/settings/actions";
import creditzActions from "../../../../redux/creditz/actions";
import { convertToDate, sorttimestamp } from "../../../../assets/constants";

const MusicTab = ({ history }) => {
  const [videoHidden, setVideoHidden] = useState(false);
  const [hiddenList, setHiddenList] = useState([]);
  const dispatch = useDispatch();
  const { creditz = [], currentUser } = useSelector((state) => ({
    creditz: state.profile.creditz,
    currentUser: state.profile.currentUser,
  }));

  useEffect(() => {
    setVideoHidden(currentUser.videoHidden);
  }, [currentUser.videoHidden]);

  useEffect(() => {
    setHiddenList(creditz);
  }, [creditz]);

  const viewVideo = (video) => {
    dispatch({
      type: creditzActions.SET_STATE,
      payload: { viewCreditzProfile: video },
    });
    history.push("/creditz");
  };

  const updateHiddenList = (music) => {
    const list = [...hiddenList];
    for (const i in list) {
      if (list[i].id === music.id) {
        list[i].hidden = !list[i].hidden;
        break;
      }
    }
    setHiddenList(list);
  };

  const save = () => {
    dispatch({
      type: settingsActions.HIDE_SHOW_MUSIC,
      payload: {
        videoHidden: videoHidden,
        musicHidden: currentUser.musicHidden,
        hiddenList: hiddenList,
      },
    });
  };

  return (
    <div className={styles.musicTab}>
      <div className={styles.topContainer}>
        <div className={styles.saveButton}>
          <button onClick={() => save()}>Save</button>
        </div>
        <Row justify="space-between" align="top" className={styles.topContent}>
          <Col span={8} className={styles.showHide}>
            <div
              onClick={() => setVideoHidden(!videoHidden)}
              className={`${styles.select} ${
                !videoHidden ? styles.selected : ""
              }`}
            />
            <div>Show/Hide on profile page</div>
          </Col>
          <Col span={6} className={styles.showHide}>
            <div>
              Select{" "}
              <span>
                {hiddenList.filter((a) => !a.hidden && a.videoTrackName).length}
              </span>{" "}
              Featured
            </div>
          </Col>
          <Col span={6}>
            <div className={styles.total}>
              <span>{creditz.filter((a) => a.videoTrackName).length}</span>{" "}
              Total
            </div>
          </Col>
        </Row>
      </div>
      <div className={styles.header}>
        <div className={styles.selectdiv}>Select</div>
        <div className={styles.title}>Title</div>
        <div className={styles.artwork}>Artwork</div>
        <div className={styles.role}>Role</div>
        <div className={styles.creator}>Creator</div>
        <div className={styles.creditors}>Creditors</div>
        <div className={styles.date}>Date</div>
        <div className={styles.action} />
      </div>
      <hr className={styles.hr} />
      <div className={styles.content}>
        {hiddenList
          .filter((a) => a.videoTrackName)
          .sort((a, b) => sorttimestamp(a, b))
          .map((video) => {
            return (
              <div className={styles.row} key={video.id}>
                <div className={styles.selectdiv}>
                  <div
                    onClick={() => updateHiddenList(video)}
                    className={`${styles.select} ${
                      !video.hidden ? styles.selected : ""
                    }`}
                  />
                </div>
                <div className={styles.title}>{video.videoTrackName}</div>
                <div className={styles.artwork}>
                  <img src={video.videoImage} alt="musicImg" />
                </div>
                <div className={styles.role}>
                  <div>Artist</div>
                </div>
                <div className={styles.creator}>
                  @{video.artistName ? video.artistName : currentUser.username}
                </div>
                <div className={styles.creditors}>
                  {video.creditors?.length > 0 ? video.creditors.length : 1}
                </div>
                <div className={styles.date}>
                  {convertToDate(video.timestamp)}
                </div>
                <div className={styles.action}>
                  <button onClick={() => viewVideo(video)}>View</button>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default withRouter(MusicTab);
